import React, { useState, useEffect } from 'react';

const TimeAgo = ({ dateString }) => {
  const [timeAgo, setTimeAgo] = useState("");

  // Function to calculate time difference and format the output
  const calculateTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();

    const diffInMs = now - date;
    const diffInSeconds = Math.floor(diffInMs / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);

    let timeString = "";

   /* if (diffInDays > 0) {
      timeString = `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
    } else if (diffInHours > 0) {
      timeString = `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;
    } else if (diffInMinutes > 0) {
      timeString = `${diffInMinutes} minute${diffInMinutes > 1 ? 's' : ''} ago`;
    } else {
      timeString = `${diffInSeconds < 0 ? 0 : diffInSeconds} second${diffInSeconds > 1 ? 's' : ''} ago`;
    }*/

    if (diffInDays > 0) {
      timeString = `${diffInDays}d ago`;
    } else if (diffInHours > 0) {
      timeString = `${diffInHours}h ago`;
    } else if (diffInMinutes > 0) {
      timeString = `${diffInMinutes}m ago`;
    } else {
      timeString = `${diffInSeconds < 0 ? 0 : diffInSeconds}s ago`;
    }

    setTimeAgo(timeString);
  };

  useEffect(() => {
    calculateTimeAgo(dateString); // Initial calculation

    // Set up an interval to update the time every 2 minutes
    const intervalId = setInterval(() => {
      calculateTimeAgo(dateString);
    }, 30000); // 120,000 ms = 2 minutes

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, [dateString]); // Only run the effect if dateString changes

  return <span>{timeAgo}</span>;

};

export default TimeAgo;
